/**
 * Preventa Cart Restriction
 * Intercepts checkout if products with "data-is-preventa" attribute are present.
 */
document.addEventListener('DOMContentLoaded', function () {
    const PREVENTA_KEY = 'preventa_accepted';

    function initPreventaCheck() {
        document.addEventListener('click', function (e) {
            const button = e.target.closest('[name="checkout"], .t4s-btn__checkout, .cdfy-check, [name="goto_checkout"], .checkout-button');

            if (!button) return;

            // Check for preventa items
            const preventaItems = document.querySelectorAll('[data-is-preventa="true"]');

            if (preventaItems.length > 0) {
                // If already accepted in this session, allow
                if (window._preventaAccepted) return;

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                showPreventaModal();
            }
        }, true); // Capture phase
    }

    function showPreventaModal() {
        const modal = document.getElementById('preventa-restriction-modal');
        if (!modal) {
            console.warn('Preventa modal not found');
            if (confirm('Tu pedido tiene artículos de preventa por lo que se enviará hasta que todos los productos estén disponibles.')) {
                window._preventaAccepted = true;
                // Find and click the checkout button again
                const btn = document.querySelector('[name="checkout"], .t4s-btn__checkout, .cdfy-check');
                if (btn) btn.click();
            }
            return;
        }

        modal.classList.add('open');

        // Close handlers
        const closeBtns = modal.querySelectorAll('.prm-close');
        const okBtn = modal.querySelector('#preventa-restriction-ok');

        console.log('Preventa modal opened', { closeBtns, okBtn });

        const closeModal = () => {
            console.log('Closing preventa modal');
            modal.classList.remove('open');
        };

        closeBtns.forEach(btn => btn.onclick = closeModal);

        modal.onclick = (e) => {
            // Background click
            if (e.target === modal) closeModal();
            // Also close on .prm-close explicitly if needed, but the loop above handles it
        };

        if (okBtn) {
            okBtn.onclick = () => {
                console.log('Preventa accepted');
                closeModal();
                window._preventaAccepted = true;

                // Re-trigger checkout
                setTimeout(() => {
                    const btn = document.querySelector('[name="checkout"], .t4s-btn__checkout, .cdfy-check');
                    if (btn) {
                        console.log('Re-triggering checkout click');
                        btn.click();
                    } else {
                        console.error('Checkout button not found for re-trigger');
                    }
                }, 300);
            };
        }
    }

    // Init
    initPreventaCheck();
});
